export const extractAdIdsFromChannels = channelsData => {
  const adIds = []
  if (channelsData.length > 0) {
    for (const channelData of channelsData) {
      const adId = channelData?.data?.ad?.adId

      if (adId) {
        let parsedAdId
        try {
          parsedAdId = JSON.parse(adId)
        } catch (err) {
          parsedAdId = adId
        }
        adIds.push(parsedAdId)
      }
    }
  }
  return adIds
}

export const mapAdsInfo = adsInfo => {
  let tempObj = {}
  for (const ad of adsInfo) {
    tempObj = {...tempObj, [ad.id]: ad}
  }
  return tempObj
}
